'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    aggregationType: 'SUM',
    valueType: 'NUMBER'
};
module.exports = exports['default'];
//# sourceMappingURL=dataElement.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/dataElement.js
// module id = 88
// module chunks = 0